













































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { DxSelectBox } from 'devextreme-vue';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract,
    AuthServiceContract,
    SignInType,
    DialogButton,
    WindowsServiceContract
} from '@/core/contracts';

import { Role } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';

interface IUserModel {
    id: number;
    name: string;
    role: Role;
}

@Component({
    components: {
        DxSelectBox
    }
})
export default class ContextSettingsUsersComponent extends Vue {
    public inLoading: boolean = false;
    public isBusy: boolean = false;
    public loadedUsers: IUserModel[] = [];
    public loadedRoles: Role[] = [];

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;

    public async mounted() {
        this.loadUsers();
        this.loadRoles();
    }

    public async changeUserRole(
        item: IUserModel,
        selectedRole: Role
    ): Promise<void> {
        if (item.role.id !== selectedRole.id) {
            this.isBusy = true;
            try {
                const currentContextId = ContextsState.currentContextId;
                const roles = await this._fetchService!.put(
                    '/contexts/' +
                    currentContextId +
                    '/users/' +
                    item.id +
                    '/role',
                    selectedRole.id
                );
            } finally {
                this.isBusy = false;
            }
        }
    }

    public async deleteUser(userId: number, userName: string): Promise<void> {
        const title = localize('UsersDeleteMessage') as string;
        const selectedBtn = await this._windowsService!.showDialog(
            title.replace('{0}', userName),
            [
                {
                    id: 0,
                    caption: localize('ContextsDelete')
                },
                {
                    id: 1,
                    caption: localize('ContextsCancel')
                }
            ]
        );
        if (selectedBtn === 0) {
            this.inLoading = true;
            try {
                const currentContextId = ContextsState.currentContextId;
                await this._fetchService!.delete(
                    '/contexts/' +
                    currentContextId +
                    '/users/' +
                    userId +
                    '/delete'
                );
                this.loadUsers();
            } finally {
                this.inLoading = false;
            }
        }
    }

    private async loadRoles(): Promise<void> {
        if (this.loadedRoles.length === 0) {
            const currentContextId = ContextsState.currentContextId;
            const roles = await this._fetchService!.get<Array<Role>>(
                '/contexts/' + currentContextId + '/roles'
            );
            this.loadedRoles = roles;
        }
    }

    private async loadUsers(): Promise<void> {
        this.inLoading = true;
        try {
            const currentContextId = ContextsState.currentContextId;
            const loadedSettings = await this._fetchService!.get<
                Array<IUserModel>
            >('/contexts/' + currentContextId + '/users');
            this.loadedUsers = loadedSettings;
        } finally {
            this.inLoading = false;
        }
    }
}
